import React from "react";
import { Card, Row, Col, Typography } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const AdminDashboard = () => {
  // Example static data (you can fetch from backend later)
  const stats = [
    {
      title: "Total Users",
      value: 1245,
      icon: <TeamOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Active Users",
      value: 980,
      icon: <UserOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Pending Approvals",
      value: 45,
      icon: <CheckCircleOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Rejected Approvals",
      value: 12,
      icon: <CloseCircleOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Eye Analyses Performed",
      value: 3870,
      icon: <EyeOutlined className="text-[#1c5a85] text-3xl" />,
    },
  ];

  return (
    <div className="min-h-screen bg-white p-6">
      <Title level={4} className="!text-[#1c5a85] !font-semibold mb-6">
        Admin Dashboard Overview
      </Title>

      <Row gutter={[24, 24]}>
        {stats.map((stat, index) => (
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            key={index}
          >
            <Card
              hoverable
              className="rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all"
            >
              <div className="flex items-center justify-between">
                <div>
                  <Text className="text-gray-500 text-sm">{stat.title}</Text>
                  <Title level={3} className="!m-0 !text-[#1c5a85]">
                    {stat.value}
                  </Title>
                </div>
                <div className="bg-[#1c5a85]/10 p-3 rounded-full">
                  {stat.icon}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AdminDashboard;
